(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-swatches"] && !Shopify.designMode) return;
  try {
    class WlCardSwatches extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('[data-product-card]');
    if (!this.card) return;
    this.buttons = Array.from(this.querySelectorAll('button[data-variant-id]'));
    this.addEventListener('click', (event) => {
      const btn = event.target.closest('button[data-variant-id]');
      if (btn) this.select(btn, true);
    });
    // Sync links and add-to-cart with the swatch that matches the image shown.
    const initial = this.querySelector('[aria-pressed="true"]');
    if (initial) this.select(initial, false);
  }

  select(btn, swapImage) {
    this.buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));

    this.card.querySelectorAll('[data-card-link]').forEach((link) => {
      link.href = btn.dataset.variantUrl;
    });

    const idInput = this.card.querySelector('[data-card-variant-id]');
    if (idInput) idInput.value = btn.dataset.variantId;

    const add = this.card.querySelector('[data-card-add]');
    if (add) {
      const available = btn.dataset.available === 'true';
      add.disabled = !available;
      add.textContent = available ? add.dataset.labelAdd : add.dataset.labelSoldOut;
    }

    const img = this.card.querySelector('[data-card-image]');
    if (swapImage && img && btn.dataset.image) {
      img.srcset = btn.dataset.srcset || '';
      img.src = btn.dataset.image;
      if (btn.dataset.alt) img.alt = btn.dataset.alt;
    }
  }
}

if (!customElements.get('wl-card-swatches')) {
  customElements.define('wl-card-swatches', WlCardSwatches);
}
  } catch(e) { console.error(e); }
})();

})();
